var signUpDrawer = require('src/interlock/profile/sign-up/sign-up-drawer');
var signInDrawer = require('src/interlock/profile/sign-in/sign-in-drawer');
var forgotPasswordDrawer = require('src/interlock/profile/forgot-password/forgot-password-drawer');

$(document).on('firebase.initialized', function() {
    var firebase = window.firebase;

    signUpDrawer.init(firebase);
    signInDrawer.init(firebase);
    forgotPasswordDrawer.init(firebase);
});


//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/profile/profile.js
// module id = 76
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14